import { ThemeOption } from '@helpers/brand';
import { combineRefs } from '@helpers/combineRefs';
import { Device, until } from '@helpers/media';
import { withBaseProps } from '@hoc/withBaseProps';
import { useCarousel } from '@hooks/useCarousel';
import { ButtonType } from '@stories/Components/Buttons/Button/ButtonType';
import LinkButton from '@stories/Components/Buttons/LinkButton/LinkButton';
import ArticleCard from '@stories/Components/Cards/ArticleCard/ArticleCard';
import DotPagination from '@stories/Components/Misc/DotPagination/DotPagination';
import * as React from 'react';
import { useSwipeable } from 'react-swipeable';
import { useMedia } from 'react-use';
import S from './LatestArticles.styles';
const LatestArticles = (props) => {
    const carousel = useCarousel({ count: props.items.length });
    // Only want carousel behavior on mobile/tablet layout.
    const enableCarousel = props.singleSlide ? true : useMedia(until(Device.DesktopSmall), false);
    /**
     * Used to remove display requirement for overflowing cards (mobile only) when carousel is
     * interacted with, because visibility: hidden; fix causes button icons to vanish
     */
    const [hideOverflow, setHideOverflow] = React.useState(true);
    const swipeHandlers = useSwipeable({
        onSwipedLeft: () => {
            carousel.goToNext(false);
            if (hideOverflow) {
                setHideOverflow(false);
            }
        },
        onSwipedRight: () => {
            carousel.goToPrev(false);
            if (hideOverflow) {
                setHideOverflow(false);
            }
        },
    });
    return (React.createElement(S.Container, { id: props.id, theme: props.theme ? props.theme : ThemeOption.Grey, "data-single-slide": props.singleSlide },
        React.createElement(S.Inner, { ...swipeHandlers, ref: combineRefs(carousel.refContainer, swipeHandlers.ref) },
            props.title && React.createElement(S.Title, null, props.title),
            props.content && React.createElement(S.Content, { dangerouslySetInnerHTML: { __html: props.content } }),
            React.createElement(S.List, { ref: carousel.refTrack, style: {
                    transform: enableCarousel ? `translateX(-${carousel.offset}px)` : undefined,
                    '--count': props.items.length,
                } }, props.items.map((item, index) => (React.createElement(S.Item, { key: item.id, ...(hideOverflow ? { 'data-active-item': carousel.activeIndex === index } : {}) },
                React.createElement(ArticleCard, { ...item }))))),
            React.createElement(DotPagination, { ariaLabel: `${props.title} carousel controls`, count: carousel.maxIndex, value: carousel.activeIndex, onChange: (value) => {
                    carousel.goToIndex(value);
                    if (hideOverflow) {
                        setHideOverflow(false);
                    }
                } }),
            props.cta && (React.createElement(S.CtaWrapper, null,
                React.createElement(LinkButton, { buttonType: ButtonType.Outline, href: props.cta.url, target: props.cta.target }, props.cta.text))))));
};
export default withBaseProps(LatestArticles);
